import { HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ClientBookingSlotRequestBody } from '@app/features-modules/client/appoinment-form/confirmation/confirmation.component';
import { environment } from '@env/environment';
import storageService from '@shared/storage/storageService';

@Injectable({
  providedIn: 'root'
})

export class ApiCall {

  private BASEURL = environment.BASE_URL;
  private OUTLOOKURL = environment.OUTLOOK_URL;
  

  token: string = "";
  outlookAccessToken: any;
  outlookRefreshToken: any;

  constructor(
    public httpClient: HttpClient,
  ) { }

  loginUser(user: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/token/generate-token`,user); 
  }
  
  /* This is Exchange login api*/
  doExchangeLogin(exchangeDTO: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/exchange/login`,exchangeDTO); 
  }
  
  getToken(){
    this.token = storageService.getItemAsJSON("token");
    return this.token;
  }
  
  getOutlookAccessToken(){
    this.outlookAccessToken = storageService.getItemAsJSON("outlookAccessToken");
    return this.outlookAccessToken;
  }

  getOutlookRefreshToken(){
    this.outlookRefreshToken = storageService.getItemAsJSON("outlookRefreshToken");
    return this.outlookRefreshToken;
  }

  setOutlookTokens(outlookAccessToken, outlookRefreshToken, tokenType){
    this.outlookAccessToken = storageService.setItemAsJSON("outlookAccessToken", tokenType + " " + outlookAccessToken);
    this.outlookRefreshToken = storageService.setItemAsJSON("outlookRefreshToken", tokenType + " " + outlookRefreshToken);
  }

  forgetPassword(user: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/user/forgot`,user); 
  }

  resetPassword(newPassword: any,email:string) {
    return this.httpClient.post<any>(`${this.BASEURL}/user/reset`,{newPassword,email}); 
  }


  validateResetToken(token) {
    return this.httpClient.get<any>(`${this.BASEURL}/user/resetToken/verify?token=${token}`); 
  }

  getCurrentUser(){
    return this.httpClient.get<any>(`${this.BASEURL}/user/currentUser`); 
  }

  findByClientId(id: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/user/client/organization/${id}`);
  }
  
  addOrganization(organization: any){
    return this.httpClient.post<any>(`${this.BASEURL}/organization/create`,organization);
  }

  addUser(user: any){
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/user/add`,user);
  }

  addCriteria(criteria: any,isAcc: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/criteriaGrid/create/${isAcc}`,criteria);
  }

  addSubTitleCriteria(data : any){
    return this.httpClient.post<any>(`${this.BASEURL}/evalution/create/subtitle/criteria`, data)
  }
  addSpecialityCriteria(criteria: any , isSpeciality: any, isDepartment : any){
    return this.httpClient.post<any>(`${this.BASEURL}/criteriaGrid/create/speciality/${isSpeciality}/${isDepartment}`,criteria);
  }


  addActivitySector(activity: any,clientId: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/activity/create/${clientId}`,activity);
  } 

  getActivitySectorByIds(list: any, isAcc:boolean , isChartDropDown : any , isIdentifyCustNeed : any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ids', list);
    return this.httpClient.get<any>(`${this.BASEURL}/activity/find/list/${isAcc}/${isChartDropDown}/${isIdentifyCustNeed}`,{params: httpParams});
  } 

  getTitleCriteriaByIds(list: any , isChartDropDown : any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ids', list);
    return this.httpClient.get<any>(`${this.BASEURL}/activity/find/list/isChartDropDown/${isChartDropDown}`,{params: httpParams});
  } 

  getActivitySectorId(activitySector : any){
    return this.httpClient.get<any>(`${this.BASEURL}/activity/find/activitySector/${activitySector}`)
  }

  getDepartmentCriteriaByIds(list: any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ids', list);
    return this.httpClient.get<any>(`${this.BASEURL}/activity/find/department/list`,{params: httpParams});
  } 

  getAllEvaluationDepartment(organizationId : any,type : any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/find/Department/${organizationId}/${type}`,);
  }

  getAllSpecilaityCriteria(isSpeciality: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/activity/find/list/isSpeciality/${isSpeciality}`);

  }

  getAllEvaluationGrade(organizationId : any ,type : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/find/grade/${organizationId}/${type}`);

  }

  findGridCriteriaById(id: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/${id}`);
  }

  findGridCriteriaByClientId(id: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/client/${id}`);
  }

  findGridCriteriaByClientIdAndIsAcc(id: any,isAcc: any,isIdentifyCustGrid : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/client/${id}/${isAcc}/${isIdentifyCustGrid}`);
  }
  findClientIdsByAccoutant(accountantId: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/fetch/${accountantId}/client/list`);
  }
  findClientNameByOrganizationId(organizationId: any, isClient : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/fetch/${organizationId}/users/${isClient}/list`);
  }
  clientTitleAssignment(data: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/criteriaGrid/assignTitle`, data);
  }

  accEvlTitleAssignment(data: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/evalution/assignTitle`, data);
  }
  
  getAssignedTitleClients(titleId : any ,isEmpSatisfaction : any , identCustNeed : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/getAssignTitle/${titleId}/${isEmpSatisfaction}/${identCustNeed}`);
  }

  geAssignedAccTitle(organizationId : any, type :any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/getAssignTitle/${organizationId}/${type}`);

  }

  findGridCriteriaByOrgId(id: any, clientId : any,isAcc: any, isIdentifyCustGrid : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/Org/${id}/${clientId}/${isAcc}/${isIdentifyCustGrid}`);
  }

  // evaluation criteria 
  findEvaluationCriteriaGrid(isGrade : any , isDepartment : any, isChief, accountantId , type) {
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/getAll/criteria/${isGrade}/${isDepartment}/${isChief}/${accountantId}/${type}`);
  }

  retriveCACriteria(feedbackId : any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/CACriteria/${feedbackId}`);
  }

  findCustPosrtfolioGridCriteriaByOrgId(id: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/criteria/Org/${id}`);
  }

  findSpecialityCriteriaByOrgId(organizationId: any, isSpeciality: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/Org/${organizationId}/isSpeciality/${isSpeciality}`);
  }

  findSpecialityCriteriaByOrgIdandSpecialityId(organizationId: any, specialityId: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/accountant/specilaity/${organizationId}/${specialityId}`);
  }

  findDepartmentCriteriaByOrgIdAndDepartmentName(organizationId: any, accId : any) {
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/accountant/department/${organizationId}/${accId}`);
  }

  findGridCriteriaByListId(list: any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ids', list);
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/find/list`,{params: httpParams});
  }

  deleteGridCriteriaById(id: any) {
    return this.httpClient.delete<any>(`${this.BASEURL}/criteriaGrid/delete/${id}`);
  }

  deleteEvlCriteriaById(id: any) {
    return this.httpClient.delete<any>(`${this.BASEURL}/evalution/delete/criteria/${id}`);
  }

  deleteTitleById(id : any){
    return this.httpClient.delete<any>(`${this.BASEURL}/criteriaGrid/delete/title/${id}`);
  }

  deleteEvlTitleById(id : any){
    return this.httpClient.delete<any>(`${this.BASEURL}/evalution/delete/title/${id}`);
  }

  deleteSubTitleById(id : any){
    return this.httpClient.delete<any>(`${this.BASEURL}/evalution/delete/subtitle/${id}`);
  }

  updateGridCriteriaById(data: any) {
    return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/update`,data);
  }

  // update subtitle criteria 
  updateSubtitleCriteriaById(data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/update/criteria`,data);
  }

  updateTitleName(data : any, titleName : any){
    return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/update/title/${titleName}`,data);
  }

  updateEvaluationTitleName(data : any, titleName : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/update/title/${titleName}`,data);
  }
  // update subtitle 
  updateEvalSubTitleName(data : any, subtitleName : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/update/subtitle/${subtitleName}`,data);
  }


  ActiveInacativeCriteria(isActive ,userId : any, id: any,data:any) {
    return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/update/criteriaId/${id}/${userId}/isActive/${isActive}`, data);
  }

  activeInactiveEvalCriteria(isActive , data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/criteria/active/${isActive}`, data);

  }

  ActiveInactiveTitle(isActive , id : any, activeTitleId : any , data : any){
  return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/update/titleId/${id}/activeTitleId/${activeTitleId}/isActive/${isActive}`,data)
  }

  // subtitle active/inactivate
  ActiveInactiveSubtitleTitle(data : any , isActive : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/title/activate/${isActive}`,data)
    }

    setCriteriaResponseTypeAndTarget(feedbackType : any , rating : any , data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/feedbackType/${feedbackType}/target/${rating}`,data)

    }

    setSubtitleResponseType(subtitleType : any , data : any){
      return this.httpClient.put<any>(`${this.BASEURL}/evalution/subtitleType/${subtitleType}`,data)
  
      }
  
  getOrganisationList(){
    return this.httpClient.get<any>(`${this.BASEURL}/organization/getOrganizationList`);
  }

  changedPassword(oldPassword: any, newPassword: any, email: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/user/changePassword`,{oldPassword, newPassword, email}); 
  }

  getAllUserList(){
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/user/list`);
  }

  deleteSuperAdminUser(userId:any){
    return this.httpClient.delete<any>(`${this.BASEURL}/administrator/user/delete/${userId}`);
  }

  deleteSuperAdminOrganization(organizationId:any){
    return this.httpClient.delete<any>(`${this.BASEURL}/organization/${organizationId}`);
  }

  /**
   * This API deletes the Organization along with all it's users
   * @returns Deleted organization
   */
  softDeleteOrganization(organizationId: any) {
    let url = `${this.BASEURL}/organization/softDelete/${organizationId}`;
    return this.httpClient.delete<any>(url);
  }

  updateSuperAdminUser(user:any){
    return this.httpClient.put<any>(`${this.BASEURL}/administrator/user/update`,user);
  }

  setEvaluationForm(data:any){
    return this.httpClient.post<any>(`${this.BASEURL}/evalution/setEvaluation`,data);
  }

  updateSuperAdminOrganization(organization:any){
    return this.httpClient.put<any>(`${this.BASEURL}/organization/update`,organization);
  }
  

  updateOrganizationAppointmentStatus(organization:any){
    return this.httpClient.put<any>(`${this.BASEURL}/organization/update/appointment`,organization);
  }

  fetchOrgById(id:any){
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/organization/${id}/info`);
  }

  getEvalauationTab(userId : any, type : any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/getActiveEvalutionTab/${userId}/${type}`);
  }

  // api to display accountants
  getUserAccountants(userId:any){
    return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/user/${userId}/accountant/list`);
  } 

  getUserEvalAccountants(userId:any){
    return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/user/${userId}/evalAccountant/list`);
  } 

  // getAccountantsList(userId:any){
  //   return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/user/${userId}/accountant/acc/list`);
  // } 

  getUserChiefAcc(userId:any){
    return this.httpClient.get<any>(`${this.BASEURL}/userAccountant/user/${userId}/accountant/list`);
  } 

  getUserRoles(){
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/getUserRoles`);
  } 



  orgUploadProfile(file: any,userId:any, isOrgImg : any){
    return this.httpClient.post<any>(`${this.BASEURL}/user/upload/${userId}/${isOrgImg}`,file,);
  }

  uploadProfile(file: any,userId:any, isOrgImage : any){
    return this.httpClient.post<any>(`${this.BASEURL}/user/upload/${userId}/${isOrgImage}`,file,);
  }

  // uploadFeedbackPDF(formData: any,feedbackId:any){
  //   return this.httpClient.post<any>(`${this.BASEURL}/upload/feedbackPDF/${feedbackId}`, formData);
  // }

  uploadFeedbackPDF(feedbackId : any , formData: FormData) {
    let url = `${this.BASEURL}/evalution/upload/feedbackPDF/${feedbackId}`;
    return this.httpClient.post(url, formData);
  }

  // uploadFeedbackPDF(formData: FormData, feedbackId: any) {
  //   return this.httpClient.post<any>(
  //     `${this.BASEURL}/upload/feedbackPDF/${feedbackId}`,
  //     formData,
  //     {
  //       headers: { 'Content-Type': 'multipart/form-data' } // Set the correct content type
  //     }
  //   );
  // }
  

  updateUserProfile(userProfile: any, userId: any) {
    return this.httpClient.put<any>(`${this.BASEURL}/user/update/${userId}`, userProfile);
  }

  getAccountants(organizationId: string) {
    return this.httpClient.get<any>(`${this.BASEURL}/organization/${organizationId}/accountants`);
  }

  getCaAccountants(organizationId: string) {
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/acc/org/${organizationId}`);
  }

  assignAccountants(userId: any, accountants: any[]) {
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/user/${userId}/accountant/add`, accountants);
  }


  assignEvalAccountants(userId: any, accountants: any[]) {
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/user/${userId}/evalAccountant/add`, accountants);
  }

  findActiveEvaluationForm(organizationId : any , type : any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/form/${organizationId}/${type}`);

  }



  /**
   * This API gets all specializations 
   * @returns List of specializations
   */
  getSpecializations() {
    let url = `${this.BASEURL}/specialization/getAll`;
    return this.httpClient.get<any>(url);
  }

  getDepartments(){
    let url = `${this.BASEURL}/department/getAll`;
    return this.httpClient.get<any>(url);
  }

  /**
   * This API gets all specializations of particular user
   * @param userId 
   * @returns List of specializations associated with particular user
   */
  getSpecializationsOfUser(userId: any) {
    let url = `${this.BASEURL}/specialization/getAll/${userId}`;
    return this.httpClient.get<any>(url);
  }

  getDepartmentOfUser(userId : any){
    let url = `${this.BASEURL}/department/getAll/${userId}`;
    return this.httpClient.get<any>(url);
  }

  /**
   * This API activate/inactivate the organization along with all it's users
   * @param organizationId 
   * @param active 
   * @returns active/inactive organization
   */
  activeInactiveOrganization(organizationId, active): any {
    let url = `${this.BASEURL}/organization/activeInactive`;
    return this.httpClient.put<any>(url, {}, {
      params: {
        id: organizationId,
        active: active
      }
    });
  }

  updateUserRole(id,roles) {
    return this.httpClient.put<any>(`${this.BASEURL}/administrator/user/role/update`, {id,roles});
  }

  deleteAssignAccountantToClient(userId,accountantId){
    return this.httpClient.delete<any>(`${this.BASEURL}/administrator/user/${userId}/accountant/${accountantId}`);
  }

  deleteAssignEvalAccountantToClient(userId,accountantId){
    return this.httpClient.delete<any>(`${this.BASEURL}/administrator/user/${userId}/evalAccountant/${accountantId}`);
  }

  unassignTitle(clientId , titleId, identNeed ){
    return this.httpClient.delete<any>(`${this.BASEURL}/criteriaGrid/unassignTitle/${clientId}/${titleId}/${identNeed}`)
  }

  unassignTitleBySectorId(sectorId , titleId, identNeed){
    return this.httpClient.delete<any>(`${this.BASEURL}/criteriaGrid/unassignTitleSector/${sectorId}/${titleId}/${identNeed}`)
  }

  unAssignedEvaluationTitle(userId , titleId ){
    return this.httpClient.delete<any>(`${this.BASEURL}/evalution/unassignTitle/${userId}/${titleId}`)
  }
  
  /**
   * This API creates users in bulk using xlsx file
   * @param formData Will contain xlsx file to create the users
   * @returns If no users is created then API will return status = "FAIL"
   * @returns If some users are created and but some are failed then API will return "success" and "failed" arrays
   */
  createUsersInBulk(formData: FormData) {
    let url = `${this.BASEURL}/administrator/upload/user`;
    return this.httpClient.post(url, formData);
  }
 // Questinarie -stepper form integration
  getQuestionCategory() {
    return this.httpClient.get<any>(`${this.BASEURL}/question/category/getAll`);
  }

  getQuestionSubCategory(questionId){
    return this.httpClient.get<any>(`${this.BASEURL}/question/category/${questionId}/subCategory/findAll`);
  }

  getQuestionBasedOnSubCategory(categoryId,subCategoryId){
    return this.httpClient.get<any>(`${this.BASEURL}/question/category/${categoryId}/subCategory/${subCategoryId}/findAll`);
  }

  getQuestionMetadata(categoryId,subCategoryId){
    return this.httpClient.get<any>(`${this.BASEURL}/question/category/${categoryId}/subCategory/${subCategoryId}/getMetadata`);
  }

  //Client-appoinment page
  getMyAppoinmentDetails(userId){
    return this.httpClient.get<any>(`${this.BASEURL}/usercase/find/user/${userId}`);
  }
  
   //delete accountant
   deleteAccountantOnClientPage(userCaseId){
    return this.httpClient.delete<any>(`${this.BASEURL}/usercase/${userCaseId}/delete`);
  }

  //upload document
  uploadDocument(userId,userCaseId,file){
    return this.httpClient.post<any>(`${this.BASEURL}/usercase/upload/user/${userId}/usercase/${userCaseId}`,file);
  }
  //usercase service
  saveUserCase(userCaseData){
    return this.httpClient.post<any>(`${this.BASEURL}/usercase/save`,userCaseData);
  }
  updateUserCase(userCase) {
    return this.httpClient.put<any>(`${this.BASEURL}/usercase/update`,userCase);
  }

  //Accountant - approved/reject appoinment
  approvedRejectAppoinment(usercaseIdAndStatus){
    return this.httpClient.post<any>(`${this.BASEURL}/usercase/usercaseStatus/update`,usercaseIdAndStatus);
  }

  /**
   * Gets all accountants booking slots
   * @returns 
   */
  getAllAccountantBookingSlots() {
    return this.httpClient.get<any>(`${this.BASEURL}/accountantBooking/findAll`);
  }
  
  /**
   * Gets all booking slots of particular accountant
   * @param accountantId 
   * @returns 
   */
  getAccountantBookingSlotsByAccountantId(accountantId: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/accountantBooking/findAll/${accountantId}`);
  }

  getAccountantBookingActiveSlotsByAccountantId(accountantId: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/accountantBooking/active/findAll/${accountantId}`);
  }

  /**
   * Creates Accountant/CA booking slot
   * @param requestBody 
   */
  createAccountantBookingSlot(requestBody: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/accountantBooking/add`, requestBody);
  }
  
  /**
   * Deletes the Accountant/CA booking slot
   * @param slotId 
   * @returns 
   */
  deleteAccountantBookingSlot(slotId: any) {
    return this.httpClient.delete<any>(`${this.BASEURL}/accountantBooking/delete/${slotId}`);    
  }
  
  /**
   * Updates Accountant/CA booking slot
   * @param requestBody 
   * @returns 
   */
  updateAccountantBookingSlot(requestBody: any) {
    return this.httpClient.put<any>(`${this.BASEURL}/accountantBooking/update`, requestBody);
  }

  /**
   * Created client booking slot
   * @param clientBookingSlot 
   * @returns 
   */
  createClientBookingSlot(clientBookingSlot: ClientBookingSlotRequestBody) {
    return this.httpClient.post<any>(`${this.BASEURL}/userBooking/add`, clientBookingSlot);
  }

  //search by first and lastname
  searchAccountant(name):any{
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/search?name=${name}`);
  }

   // Download document service
   downloadDocument(userId,userCaseId,documentId):any{
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    return this.httpClient.get<any>(`${this.BASEURL}/usercase/download/user/${userId}/usercase/${userCaseId}/document/${documentId}`,httpOptions);
  }

  /**
     * This API gets the users based on their role
     * @param filterByValue (client | accountant | chief accountant | all)
     * @returns Users based on their role
     */
  getUsersByFilter(filterByValue: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('filterBy', filterByValue);
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/user`, {
      params: httpParams
    });
  }

  /**
   * This API downloads all users under particular organization in xlsx format
   * @returns xlsx file
   */
  downloadUsersUnderOrganization() {
    return this.httpClient.get<any>(`${this.BASEURL}/administrator/download/users`, {responseType: 'blob' as 'json'});
  }

  /**
   * This API checks if there meeting already scheduled for the particular date with particular appointment details
   * @param requestBody 
   * @returns 
   */
  accountantBookingVerify(requestBody: any) {
    return this.httpClient.post(`${this.BASEURL}/accountantBooking/verify`, requestBody);
  }

  /**
   * @returns User feedback metadata
   */
  getUserFeedbackMetadata() {
    return this.httpClient.get(`${this.BASEURL}/userFeedback/metadata/findAll`);
  }

  /**
   * This API saves the feedback given by user to organization
   * @param requestBody 
   * @returns 
   */
  saveUserFeedback(requestBody: any,isSpeciality : any, isDepartment : any, isCustomerPortfolio : any) {
    return this.httpClient.post(`${this.BASEURL}/userfeedback/save/${isSpeciality}/${isDepartment}/${isCustomerPortfolio}`, requestBody);
  }

  checkedCriteria(data : any) {
    return this.httpClient.post(`${this.BASEURL}/criteriaGrid/checked/criteria`, data);
  }

  findAccLinkedFeedback(accountantId : any){
    return this.httpClient.get(`${this.BASEURL}/userfeedback/get/linkedFeedback/${accountantId}`);
  }

  deleteLinkedFeedback(feedbackDetailId) {
    let url = `${this.BASEURL}/userfeedback/delete/linked/feedback/${feedbackDetailId}`;
    return this.httpClient.delete(url);
  }

  saveEvaluationFeedback(requestBody: any) {
    return this.httpClient.post(`${this.BASEURL}/evalution/save`, requestBody);
  }

  saveModifyEvaluationFeedback( accountant : any , requestBody: any) {
    return this.httpClient.put(`${this.BASEURL}/evalution/modify/feedback/${accountant}`, requestBody);
  }
  
  /**
   * This API returns all feedbacks for particular organization
   * @param organizationId 
   * @param chiefAccountantId 
   * @returns List of all feedbacks with average ratings
   */
  getAllFeedbacksOfOrganization(organizationId: any, chiefAccountantId: any) {
    let url = `${this.BASEURL}/userfeedback/find/organization/${organizationId}/chiefAccountant/${chiefAccountantId}`
    return this.httpClient.get(url);
  }

  /**
   * This API returns the feedback details
   * @param organizationId 
   * @param clientId 
   * @param feedbackId 
   * @returns 
   */
  getFeedbackDetails(organizationId, clientId, feedbackId,isAccData) {
    let url = `${this.BASEURL}/userfeedback/find/organization/${organizationId}/user/${clientId}/feedback/${feedbackId}/${isAccData}`;
    return this.httpClient.get(url);
  }

  getFeedbackDetailsBySpeciality(organizationId, feedbackId) {
    let url = `${this.BASEURL}/userfeedback/find/specilaity/organization/${organizationId}/feedback/${feedbackId}`;
    return this.httpClient.get(url);
  }

  getEvalFeedbackDetails(organizationId, feedbackId) {
    let url = `${this.BASEURL}/evalution/find/organization/${organizationId}/feedback/${feedbackId}`;
    return this.httpClient.get(url);
  }

  getTargetFeedback(criteriaIds : any){
    let url =`${this.BASEURL}/evalution/target/rating/${criteriaIds}`;
    return this.httpClient.get(url);
  }

  disableEvalautionFeedback(feedbackId : any){
    let url = `${this.BASEURL}/evalution/feedback/disabled/${feedbackId}`;
    return this.httpClient.put(url,feedbackId);

  }

  /**
   * This API deletes the particular feedback
   * @param clientId 
   * @param feedbackId 
   * @returns 
   */
  deleteFeedback(clientId, feedbackId) {
    let url = `${this.BASEURL}/userfeedback/delete/user/${clientId}/feedback/${feedbackId}`;
    return this.httpClient.delete(url);
  }

  deleteEvaluationFeedback(userId , feedbackId, type){
    let url = `${this.BASEURL}/evalution/delete/user/${userId}/feedback/${feedbackId}/${type}`;
    return this.httpClient.delete(url);
  }

  deleteAccFeedback(clientId, feedbackId) {
    let url = `${this.BASEURL}/userfeedback/delete/user/${clientId}/accFeedback/${feedbackId}`;
    return this.httpClient.delete(url);
  }
  /**
   * This API returns all the countries (Currently only France is available under the database)
   * @returns 
   */
  getAllCountries() {
    let url = `${this.BASEURL}/location/country/findAll`;
    return this.httpClient.get(url);
  }

  /**
   * Returns all states under particular country
   * @param countryId 
   * @returns 
   */
  getAllStatesByCountry(countryId: any) {
    let url = `${this.BASEURL}/location/state/findAll`
    let httpParams = new HttpParams();
    httpParams = httpParams.append('countryId', countryId);
    return this.httpClient.get(url, {params: httpParams});
  }

  /**
   * Returns all cities under particular country and state
   * @param countryId 
   * @param stateId 
   * @returns 
   */
  getCitiesByCountryAndState(countryId: any, stateId: any) {
    let url = `${this.BASEURL}/location/city/findAll`
    let httpParams = new HttpParams();
    httpParams = httpParams.append('countryId', countryId);
    httpParams = httpParams.append('stateId', stateId);
    return this.httpClient.get(url, {params: httpParams});
  }

  /**
   * Returns organizations based on page
   * @param pageNo 
   * @param pageSize 
   * @returns 
   */
  getOrganizationByPage(pageNo, pageSize, organizationName) {
    let url = `${this.BASEURL}/organization/findAll`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNo', pageNo);
    httpParams = httpParams.append('pageSize', pageSize);
    httpParams = httpParams.append('organizationName', organizationName);
    return this.httpClient.get(url, {params: httpParams});
  }

  /**
   * Returns userd based on page
   * @param pageNo 
   * @param pageSize 
   * @returns 
   */
   getUserByPage(pageNo, pageSize, filterBy?, userName?) {
    let url = `${this.BASEURL}/administrator/findAll`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNo', pageNo);
    httpParams = httpParams.append('pageSize', pageSize);
    if (filterBy) {
      httpParams = httpParams.append('filterBy', filterBy);
    }
    if (userName) {
      httpParams = httpParams.append("userName", userName)
    }
    return this.httpClient.get(url, {params: httpParams});
  }

  getAllClient() {
    let url = `${this.BASEURL}/administrator/findAllClient`;
    return this.httpClient.get(url);
  }

  getAllAccountant(){
    let url = `${this.BASEURL}/administrator/findAllAccountant`;
    return this.httpClient.get(url);
  }

  getMyClient() {
    let url = `${this.BASEURL}/administrator/findMyClient`;
    return this.httpClient.get(url);
  }
  /**
   * Returns MyAppointment based on page
   * @param pageNo 
   * @param pageSize 
   * @returns 
   */
   getMyAppointmentByPage(pageNo, pageSize, userId, filterBy?, filterValue?,userName?) {
    let url = `${this.BASEURL}/usercase/getAll/user/${userId}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNo', pageNo);
    httpParams = httpParams.append('pageSize', pageSize);
    httpParams = httpParams.append('userId', userId);
    if (filterBy) {
      httpParams = httpParams.append('filterBy', filterBy);
    }
    if (filterValue) {
      httpParams = httpParams.append('value', filterValue);
    }
    if (userName) {
      httpParams = httpParams.append("userName", userName)
    }
    return this.httpClient.get(url, {params: httpParams});
  }
  findUserCaseByOrgId(orgId: any) {
    return this.httpClient.get<any>(`${this.BASEURL}/usercase/find/organization/usercase/${orgId}`);
  }

  //  Find Top 10 Clients
  getTopClient(orgId) {
    let url = `${this.BASEURL}/usercase/getAll/TopClient/${orgId}`;
    return this.httpClient.get(url);
  }

  /**
   * Returns feedback based on page
   * @param pageNo 
   * @param pageSize 
   * @returns 
   */
   getFeedbackByPage(accReturns,pageNo, pageSize, organizationId: any, chiefAccountantId: any,isExport: any,isAccountant: any, isIdentifyCustGrid : any, isCustPortfolio : any) {
    let url = `${this.BASEURL}/userfeedback/getAll/organization/${organizationId}/chiefAccountant/${chiefAccountantId}/${isExport}/${isAccountant}/${accReturns}/${isIdentifyCustGrid}/${isCustPortfolio}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNo', pageNo);
    httpParams = httpParams.append('pageSize', pageSize);
    return this.httpClient.get(url, {params: httpParams});
  }

  getPeriodicFeedback(type : any , isAccountant : any) {
    let url = `${this.BASEURL}/evalution/getAll/feedback/${type}/${isAccountant}`;
    return this.httpClient.get(url);
  }

  getFeedbackByPageForLineChart(accReturns,organizationId: any, chiefAccountantId: any,isAccountant: any,filterType : any,isBarChart: any, isIdentifyCustChart : any) {
    let url = `${this.BASEURL}/userfeedback/getAll/linechart/${organizationId}/chiefAccountant/${chiefAccountantId}/${isAccountant}/${accReturns}/${filterType}/${isBarChart}/${isIdentifyCustChart}`;
    return this.httpClient.get(url);
  }

  getAccFeedbackByPageForLineChart(organizationId: any, chiefAccountantId: any, filterType : any, isSpeciality : any , isDepartment : any, isBarchart, isCustPortfolio : any) {
    let url = `${this.BASEURL}/userfeedback/getAll/Empchart/${organizationId}/chiefAccountant/${chiefAccountantId}/${filterType}/${isSpeciality}/${isDepartment}/${isBarchart}/${isCustPortfolio}`;
    return this.httpClient.get(url);
  }


// Evaluation chart api 
  getEvalFeedbackForChart(organizationId: any,type , filterType : any) {
    let url = `${this.BASEURL}/evalution/evalFeedback/chart/${organizationId}/${type}/${filterType}`;
    return this.httpClient.get(url);
  }
  getDataForSectors(userFeedBacks:any,filterType : any) {
    let url = `${this.BASEURL}/userfeedback/getAll/sectors/chart/data/${filterType}`;
    return this.httpClient.post(url,userFeedBacks);
  }
          
                                
  getSpecialityFeedbackByPage(pageNo, pageSize, organizationId: any,isExport: any,isAccountant : any) {
    let url = `${this.BASEURL}/userfeedback/getAll/organization/${organizationId}/accountant/${isAccountant}/${isExport}/speciality`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNo', pageNo);
    httpParams = httpParams.append('pageSize', pageSize);
    return this.httpClient.get(url, {params: httpParams});
  }

  getSpecialityFeedbackByPageForChart(organizationId: any,isAccountant : any,filterType: any) {
    let url = `${this.BASEURL}/userfeedback/getAll/linechart/${organizationId}/accountant/${isAccountant}/speciality/${filterType}`;
    return this.httpClient.get(url);
  }
  /**
   * 
   * @returns All supported languages for localization
   */
  getAllLanguages() {
    let url = `${this.BASEURL}/localization/fetchAll`;
    return this.httpClient.get(url);
  }

  /**
   * 
   * @param userId 
   * @returns Language which is selected by user
   */
  getSelectedLanguage(userId: any) {
    let url = `${this.BASEURL}/localization/user/${userId}`;
    return this.httpClient.get(url);
  }

  setLanguage(userId: any, shortName: string) {
    let url = `${this.BASEURL}/localization/user/${userId}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append('language', shortName);
    return this.httpClient.post(url, httpParams);
  }
  

  //onSubmit Inquiry Form
  onSubmitForm(user: any) {
    return this.httpClient.post<any>(`${this.BASEURL}/accountingFirm/sendEmail`,user); 
  }
  
  /**
   * Gets all Outlook calendar events of particular accountant
   * @returns 
   */
   getAccountantOutlookEvents() {
    return this.httpClient.get<any>(`${this.OUTLOOKURL}/?$select=subject,body,bodyPreview,organizer,attendees,start,end,location,recurrence,transactionId`);
  }
  
  getOutLookCal(startDate,endDate) {
    return this.httpClient.get<any>(`https://graph.microsoft.com/v1.0/me/calendarView/delta?startDateTime=${startDate}&endDateTime=${endDate}`)
  }
    /**
   * Creates outlook slot
   * @param requestBody 
   */
     createOutlookSlot(requestBody: any) {
      return this.httpClient.post<any>(`${this.OUTLOOKURL}`, requestBody);
    }  
    
    /*
      To verify the outlook slot
    */
    verifyOutlookSlots(accountantId, slot: any){
      return this.httpClient.post<any>(`${this.BASEURL}/accountantBooking/exists/${accountantId}`,slot); 
    }
    
    verifyExchangeSlots(accountantId, slot: any){
      return this.httpClient.post<any>(`${this.BASEURL}/exchange/exists/exchange/${accountantId}`,slot); 
    }
    /*
      To remove the deleted outlook slot
    */
      delteOutLookSlotByIds(bookSlotIds: any) {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('bookSlotIds', bookSlotIds);
        return this.httpClient.delete<any>(`${this.BASEURL}/accountantBooking/delete/all`,{params: httpParams}); 
      }
  
      fetcDeleteOutlookSlot(slot:any) { 
        return this.httpClient.post<any>(`${this.BASEURL}/accountantBooking/fetch/delete/outlook/slot`,slot); 
      }

      fetchDeleteExchangeSlots(slot:any) { 
        return this.httpClient.post<any>(`${this.BASEURL}/exchange/fetch/delete/exchange/slot`,slot); 
      }

  /**
   * Create Exchnage appointment slots
   * @returns 
   */
   createExchangeAppointments(requestBody:any) {
    return this.httpClient.post<any>(`${this.BASEURL}/exchange/appointment/create`,requestBody);
  }


  fetchExchangeAppointements(requestBody:any) {
    return this.httpClient.post<any>(`${this.BASEURL}/exchange/appointment/fetch`,requestBody);
  }
  sendRequestForAppointment(data) {
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/send/email`, data);
  }

  sendReviewRequest(data: any, isIdentifyCustNeed : any , googleReview : any){
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/send/reviewRequest/${isIdentifyCustNeed}/${googleReview}`, data)
  }

  sendEvalFeedbackReq(isPeriodic : any, data : any){
    return this.httpClient.post<any>(`${this.BASEURL}/administrator/send/evalRequest/${isPeriodic}`, data)
  }

  addSingleFormTitle(title : any, isAccCriteria : any, isIdentifyCust : any){
    return this.httpClient.post<any>(`${this.BASEURL}/criteriaGrid/create/title/${isAccCriteria}/${isIdentifyCust}`, title)
  }

  // periodic evaluation form
  addEvalutionFormTitle(data : any){
    return this.httpClient.post<any>(`${this.BASEURL}/evalution/create/title`, data)
  }

  addPeriodicSubTitle(data : any){
    return this.httpClient.post<any>(`${this.BASEURL}/evalution/create/subtitle`, data)
  }

  findAllTitle(organizationId : any,isAcc : any , isChartDropDown : any, isIdentifyCust : any){
    return this.httpClient.get<any>(`${this.BASEURL}/criteriaGrid/getAll/title/${organizationId}/${isAcc}/${isChartDropDown}/${isIdentifyCust}`)

  }

  // get All evaluation title 
  findAllEvaluationTitle(type : any){
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/getAllEvaTitle/${type}`)

  }

  // get all subtitle 
  findEvlSubtitle(titleIds : any , isChart : any){
    let httpParams =  new HttpParams();
    httpParams = httpParams.append('ids' , titleIds);
    return this.httpClient.get<any>(`${this.BASEURL}/evalution/getAllSubtitle/${isChart}`, {params : httpParams})
  }

  criteriaAccountantLink(clientIds: any, accountantType : any ,data: any) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('clientIds', clientIds);
    return this.httpClient.post<any>(`${this.BASEURL}/criteriaGrid/linkAccountant/${accountantType}`, data, { params: httpParams });
}


  scheduleFeedbackByFrequency(data : any){
    return this.httpClient.post<any>(`${this.BASEURL}/cron/schedule`,data);
  }

  getClientTitleRelation(titleId: any){
    return this.httpClient.get<any>(`${this.BASEURL}/cron/client-relationship/${titleId}`); 
  }
  getAccountantTitleRelation(titleId : any){
    return this.httpClient.get<any>(`${this.BASEURL}/cron/accountant-relationship/${titleId}`); 

  }

  clearFrequencyByTitleId(titleId : any){
    return this.httpClient.delete<any>(`${this.BASEURL}/cron/delete/${titleId}`);

  }

  userDeactivate(user:any){
    return this.httpClient.put<any>(`${this.BASEURL}/user/deactivation`,user);
  }
  unsubscribeTitleForm(data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/user/unSubscribe`,data);
  }

  dragAndDropTitle(data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/reorderTitle`,data)
    }

  feedbackResponseType(rowData: any) {
     return this.httpClient.put<any>(`${this.BASEURL}/criteriaGrid/setResponseType`, rowData)
    }

      dragAndDropEvalTitle(data : any){
    return this.httpClient.put<any>(`${this.BASEURL}/evalution/reorderTitle`,data)
    }
}

